import React, { useState } from "react";
import {
  Box,
  FormControl,
  FormLabel,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Checkbox,
  Button,
  Flex,
  Text,
  Tag,
  TagLabel,
  TagCloseButton,
} from "@chakra-ui/react";
import { ChevronDown, X } from "lucide-react";

const VendorSelection = ({
  all_vendor_list,
  selectedVendor,
  setSelectedVendor,
  vendorError,
  isViewOnly,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleSelect = (vendorId) => {
    setSelectedVendor((prev) =>
      prev.includes(vendorId)
        ? prev.filter((id) => id !== vendorId)
        : [...prev, vendorId]
    );
    setIsMenuOpen(false); // ✅ Automatically close after selection
  };

  return (
    <FormControl>
      <FormLabel fontSize="md" fontWeight="medium" color="gray.600" mb={2}>
        Select Vendors
      </FormLabel>

      {/* Dropdown */}
      <Menu
        closeOnSelect={false}
        isOpen={isMenuOpen}
        onClose={() => setIsMenuOpen(false)}
        onOpen={() => setIsMenuOpen(true)}
        isDisabled={isViewOnly}
      >
        <MenuButton
          as={Button}
          rightIcon={<ChevronDown size={16} />}
          w="100%"
          textAlign="left"
          variant="outline"
          borderRadius="md"
          fontWeight="normal"
          isDisabled={isViewOnly}
        >
          {selectedVendor.length === 0
            ? "Choose vendor(s)"
            : `${selectedVendor.length} vendor(s) selected`}
        </MenuButton>

        <MenuList maxH="260px" overflowY="auto" borderRadius="md" shadow="md">
          {all_vendor_list?.map((vendor) => (
            <MenuItem
              key={vendor.vendorid}
              onClick={() => handleSelect(vendor.vendorid)}
              py={2}
            >
              <Checkbox
                isChecked={selectedVendor.includes(vendor.vendorid)}
                pointerEvents="none"
                mr={3}
                colorScheme="green"
              />
              <Box>
                <Text fontSize="sm" fontWeight="medium">
                  {vendor.tradename}
                </Text>
                {vendor.email_business && (
                  <Text fontSize="xs" color="gray.500">
                    {vendor.email_business}
                  </Text>
                )}
              </Box>
            </MenuItem>
          ))}
        </MenuList>
      </Menu>

      {/* Pills Section */}
      {selectedVendor.length > 0 && (
  <Flex mt={3} wrap="wrap" gap={2}>
    {/* ✅ Filter out duplicates before mapping */}
    {[...new Set(selectedVendor)].map((vendorId) => {
      // Try multiple ID fields to match vendors correctly
      const vendor = all_vendor_list?.find(
        (v) => v.vendorid === vendorId || v.id === vendorId || String(v.vendorid) === String(vendorId)
      );
      if (!vendor) return null;
      return (
        <Tag
          size="md"
          key={vendorId}
          borderRadius="full"
          bg="#347433"
          color="white"
        >
          <TagLabel>{vendor.tradename}</TagLabel>
          <TagCloseButton
            onClick={() =>
              setSelectedVendor((prev) =>
                prev.filter((id) => id !== vendorId)
              )
            }
            isDisabled={isViewOnly}
            opacity={isViewOnly ? 0.5 : 1}
          />
        </Tag>
      );
    })}
    <Button
      size="xs"
      variant="ghost"
      colorScheme="red"
      onClick={() => setSelectedVendor([])}
      leftIcon={<X size={14} />}
      isDisabled={isViewOnly}
    >
      Clear All
    </Button>
  </Flex>
)}

      {vendorError && (
        <Text color="red.500" fontSize="sm" mt={2}>
          {vendorError}
        </Text>
      )}
    </FormControl>
  );
};

export default VendorSelection;
